module.exports = __webpack_public_path__ + "static/media/check-big.7f30ac33.svg";